import style from './breadcrumb.scss';
import breadcrumbs from 'Assets/js/breadcrumbs-behavior';

const script = () => {
  breadcrumbs({
    cssClass: 'breadcrumb',
    targetList: 'ol',
  });
};

export {
  style,
  script,
};
